<main class="ib-layout ib-layout--bck-1"  [ngSwitch]="componentType">
    <div *ngSwitchCase="'empty'"></div>
    <ib-mmb-payment *ngSwitchCase="'new'" (returnToOld)="forceOld()"></ib-mmb-payment>
    <ib-mmb-pmt-component-legacy *ngSwitchDefault></ib-mmb-pmt-component-legacy>
</main>